import React from "react";
import {
  Container,
  LeftColumn,
  LeftColumnContent,
  RightColumn,
  RightColumnContent
} from "@/components/pages/settings/form_fields/FormFieldManagement.styles";
import FormFieldNameTable from "@/components/pages/settings/form_fields/FormFieldNamesTable";
import FormFieldCategoriesTable from "@/components/pages/settings/form_fields/FormFieldCategoriesTable";

export default function FormFields() {

  return (
    <>
      <Container>
        <LeftColumn>
          <LeftColumnContent>
            <FormFieldNameTable/>
          </LeftColumnContent>
        </LeftColumn>
        <RightColumn>
          <RightColumnContent>
            <FormFieldCategoriesTable
            />
          </RightColumnContent>
        </RightColumn>
      </Container>
    </>
  );

}
